import {ACTION_TYPE} from "utils/constants";

export const updateUserInfo = userinfo => ({
  type: ACTION_TYPE.UPDATE_USERINFO,
  payload: userinfo,
});

export const logout = () => ({
  type: ACTION_TYPE.LOGOUT,
  payload: {},
});

export const login = userinfo => ({
  type: ACTION_TYPE.LOGIN,
  payload: userinfo,
});
